import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from '../../../templates/services/base-service.template';
import { Core2Config } from '../../../utils/core2-config';
import { ApiVisa } from '../../../models/base/apivisa.model';
import { PagingResponseModel } from '../../../models/base/paging-response.model';
import { CMSLayoutContainerModel } from '../../../models/cms/cms-layout-container.model';
import { getHttpHeader } from '../../../utils/http-header.factory';

@Injectable({
  providedIn: 'root'
})
export class CMSLayoutService implements BaseService {

  public readonly apiUrl: string = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'cms/layout-instances';

  constructor(protected readonly http: HttpClient) {}

  public getByCode(code: string, { tenantCode, api_domain_url, jwt_secret }: ApiVisa): Observable<PagingResponseModel<CMSLayoutContainerModel>>{
    return this.http.get<PagingResponseModel<CMSLayoutContainerModel>>(`${ api_domain_url }${ this.apiUrl }/public/${ code }`, getHttpHeader(jwt_secret, tenantCode));
  }
}
